import { useSelector, useDispatch } from "react-redux";
import {  fetchClinicianBySlug } from "../../redux/clinic/clinicSlice";
import { useCallback } from "react";
import { RootState } from '../../redux';
import { AppDispatch } from '../../redux';

const useFetchClinicianPublicProfile = () => {
  const dispatch = useDispatch<AppDispatch>();
  const clinicianState = useSelector((state: RootState) => state.clinics);
  
  // Fetch clinician data with optional ID parameter
  const FetchClinicianPublicProfile = useCallback(async (slug?: string) => {

    try {
    if (!slug) throw new Error('Clinician slug is required');
      const result = await dispatch( fetchClinicianBySlug(slug)).unwrap();
      return result;
    } catch (error) {
      console.error(`Failed to fetch clinician${slug ? ` with slug ${slug}` : 's'}:`, error);
      throw error;
    }
  }, [dispatch]);
  
  return { 
    ...clinicianState, 
    FetchClinicianPublicProfile
  };
};

export default useFetchClinicianPublicProfile;
